import { combineReducers } from 'redux';
import { IReducerState as ISidebarStateCPY, reducer as sidebarReducerCPY } from './init';

import { IReducerState as ISidebarState, reducer as sidebarReducer } from './root';

import { IReducerState as ISidebarPI, reducer as sidebarPIReducer } from 'ui/reducers/personalInformation';

import { IReducerState as ISidebarClinical, reducer as sidebarClinicalReducer } from 'ui/reducers/clinical';

import { reducer as errorReducer, IReducerState as IErrorState } from './error';

export interface IAppState {
  sidebarInit: ISidebarStateCPY;
  root: ISidebarState;
  personalInformation: ISidebarPI;
  clinical: ISidebarClinical;
  error: IErrorState;
}

const appReducer = combineReducers<IAppState>({
  sidebarInit: sidebarReducerCPY,
  root: sidebarReducer,
  personalInformation: sidebarPIReducer,
  clinical: sidebarClinicalReducer,
  error: errorReducer,
});

export const rootReducer: typeof appReducer = (state, action) => {
  if (action.type === 'PATIENTSIDEBAR/SIDEBAR/RESET') {
    state = undefined as any;
  }
  return appReducer(state, action);
};
